import { Add } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import type { ITooltipProps } from "@similarweb/ui-components";
import { Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const BrandsIndicatorComponent = ({
    brands,
    children,
    placement = "right",
}: {
    brands: string[];
    children: React.ReactNode;
    placement?: ITooltipProps["placement"];
}) => {
    if (!brands?.length) {
        return children;
    }
    const hasMultipleBrands = brands.length > 1;
    return (
        <Flex
            alignItems="center"
            height="100%"
            gap="4px"
            data-automation="brands-indicator"
            data-automation-brands={brands.join(",")}
        >
            {children}
            {hasMultipleBrands ? (
                <Tooltip
                    content={
                        <Flex
                            maxWidth="130px"
                            overflowWrap="anywhere"
                        >
                            {brands.slice(1).join(", ")}
                        </Flex>
                    }
                    placement={placement}
                >
                    <Flex
                        alignItems="center"
                        lineHeight="12px"
                    >
                        <Add
                            size={12}
                            color={colorsPalettes.carbon[400]}
                        />
                        <Text
                            fontVariant="captionTitle"
                            color={colorsPalettes.carbon[400]}
                        >
                            {brands.length - 1}
                        </Text>
                    </Flex>
                </Tooltip>
            ) : null}
        </Flex>
    );
};
